import React, { useEffect, useState } from 'react';
import InactiveModal from '../flows/inactive';
import { SESSION_POPUP_TIMES } from '../constants/general';

const events = ['keypress', 'mousemove', 'mousedown', 'scroll', 'touchmove', 'pointermove'];

const addEventListeners = (handleReset: () => void) => {
  events.forEach((type) => {
    window.addEventListener(type, handleReset, false);
  });
};
const removeEventListeners = (handleReset: () => void) => {
  if (handleReset) {
    events.forEach((type) => {
      window.removeEventListener(type, handleReset, false);
    });
  }
};

const InactiveTimer = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  useEffect(() => {
    const createModalTimeout = () => setTimeout(() => {
      setModalOpen(true);
    }, SESSION_POPUP_TIMES.OPEN_POPUP);

    let timeout = createModalTimeout();

    const handleReset = () => {
      if (!modalOpen) {
        clearTimeout(timeout);
        timeout = createModalTimeout();
      }
    };

    addEventListeners(handleReset);

    return () => {
      removeEventListeners(handleReset);
      clearTimeout(timeout);
    };
  }, [modalOpen]);

  return (modalOpen ? <InactiveModal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} /> : null);
};

export default InactiveTimer;
